import PromisePolyfill from "promise-polyfill";

// set Promise only if not defined natively
if (!window.Promise)
  window.Promise = PromisePolyfill;



// WEBPACK FOOTER //
// ./_polyfill/promise.js